// Zeitangaben für den Kopf der Bestellung (29.10.2026).
//
// Gespeichert ist UTC; gezeigt wird Ortszeit Stuttgart. Das Alter zählt
// Kalendertage in Ortszeit — „heute" heißt hier dasselbe wie am Tresen
// (Fallstrick 6: DATE ≠ UTC).

const ZONE = 'Europe/Berlin';

/** „28.10.2026, 17:47" — oder null bei fehlender/ungültiger Angabe. */
export function zeitpunktText(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(d);
}

function ortsDatum(d: Date): string {
  // en-CA liefert JJJJ-MM-TT — gut zum Rechnen.
  return new Intl.DateTimeFormat('en-CA', { timeZone: ZONE }).format(d);
}

/** „heute", „seit 1 Tag", „seit 12 Tagen" — Kalendertage in Ortszeit. */
export function alterText(iso: string | null | undefined, jetzt: Date = new Date()): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const tage = Math.round(
    (Date.parse(ortsDatum(jetzt)) - Date.parse(ortsDatum(d))) / 86_400_000
  );
  if (tage <= 0) return 'heute';
  return tage === 1 ? 'seit 1 Tag' : `seit ${tage} Tagen`;
}

/** „34,90 €" */
export function betragText(betrag: string | null, waehrung: string | null): string | null {
  if (betrag === null) return null;
  const n = Number(betrag);
  if (!Number.isFinite(n)) return null;
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: waehrung ?? 'EUR' }).format(n);
}
